<template>
    <PercentOfEntitySoldComponent v-bind="$props" :entity="MENU" />
</template>

<script>
import PercentOfEntitySoldComponent from "./PercentOfEntitySoldComponent.vue";
import { MENU } from "../../utils/stats/revenueEntities.js";

export default {
    props: {
        grid: {
            required: true,
            type: Object,
        },
        filters: {
            required: true,
            type: Object,
        },
    },
    computed: {
        MENU() {
            return MENU;
        },
    },
    components: {
        PercentOfEntitySoldComponent,
    },
};
</script>
